
<form [formGroup]="formControlGroup" (keypress)="keyboardPress($event)" (keyup)="keyboardUp($event)">

    <div class="global-container">

        <!-- Information text -->
        <div class="information_text">
            {{languageService.Strings.popups.title_setPatientId}}
        </div>

        <!-- Patient ID input -->
        <div class="input_box">
            <mat-form-field class="input-text" appearance="fill">
                <mat-label>
                    {{languageService.Strings.popups.input_box_label_patientId}}
                </mat-label>

                <input type="text" maxlength="MAX_LENGTH"  matInput [formControl]="stringFormControlPatientId" [errorStateMatcher]="matcher" 
                    required autocomplete="off">

                <mat-error *ngIf="stringFormControlPatientId.hasError('required')">
                    {{languageService.Strings.errors.error_required}}
                </mat-error>
            
                <mat-error *ngIf="stringFormControlPatientId.hasError('maxlength')">
                    {{languageService.Strings.errors.error_maxLength}} {{stringFormControlPatientId.value.length}} / {{MAX_LENGTH}}
                </mat-error>
            
                <mat-error *ngIf="stringFormControlPatientId.hasError('specialCharactersValidationError')">
                    {{languageService.Strings.errors.error_specialCharacters}}
                </mat-error>
            
                <mat-error *ngIf="stringFormControlPatientId.hasError('spacesInStringValidationError')">
                    {{languageService.Strings.errors.error_spacesInString}}
                </mat-error>
            </mat-form-field>
        </div>

        <!-- Study ID input -->
        <div class="input_box">
            <mat-form-field class="input-text" appearance="fill">
                <mat-label>
                    {{languageService.Strings.popups.input_box_label_studyId}}
                </mat-label>

                <input type="text" maxlength="MAX_LENGTH"  matInput [formControl]="stringFormControlStudyId" [errorStateMatcher]="matcher" 
                    required autocomplete="off">

                <mat-error *ngIf="stringFormControlStudyId.hasError('required')">
                    {{languageService.Strings.errors.error_required}}
                </mat-error>
            
                <mat-error *ngIf="stringFormControlStudyId.hasError('maxlength')">
                    {{languageService.Strings.errors.error_maxLength}} {{stringFormControlStudyId.value.length}} / {{MAX_LENGTH}}
                </mat-error>
            
                <mat-error *ngIf="stringFormControlStudyId.hasError('specialCharactersValidationError')">
                    {{languageService.Strings.errors.error_specialCharacters}}
                </mat-error>
            
                <mat-error *ngIf="stringFormControlStudyId.hasError('spacesInStringValidationError')">
                    {{languageService.Strings.errors.error_spacesInString}}
                </mat-error>
            </mat-form-field>
        </div>

        <!-- Actions -->
        <div class="base_buttons_container">
            <!-- Exit button --> 
            <button mat-raised-button 
                    color="primary" 
                    class="base_buttons" 
                    (click)="cancelButtonClicked()" 
                    style="width: 47%;">
                {{languageService.Strings.buttons.button_cancel}}
            </button>  
            <!-- Save button -->        
            <button mat-raised-button 
                    color="primary" 
                    class="base_buttons" 
                    (click)="acceptButtonClicked()" 
                    style="width: 47%;" 
                    [disabled]="!formControlGroup.valid"> 
                {{languageService.Strings.buttons.button_accept}}
            </button>   
        </div>
    </div>
</form>